import {
	createRef,
	ReactElement,
	ReactNode,
	RefObject,
	useEffect
} from 'react';
import { connect } from 'react-redux';
import { SnackbarKey, SnackbarProvider as NotistackProvider } from 'notistack';
import { IconButton } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

import {
	AppState,
	AppThunkDispatch,
	clearMessage,
	SnackbarActions,
	SnackbarMessage
} from '../../../redux';

import './snackbar-provider.styles.scss';

export interface ISnackbarProviderStateProps {
	queue?: SnackbarMessage;
	clearMessage: () => void;
}

export interface ISnackbarProviderOwnProps {
	children?: ReactNode;
}

function SnackbarProviderView(
	props: ISnackbarProviderStateProps & ISnackbarProviderOwnProps
): ReactElement {
	const { children, queue, clearMessage } = props;
	const snackRef: RefObject<NotistackProvider> =
		createRef<NotistackProvider>();

	useEffect(() => {
		if (queue && snackRef.current) {
			snackRef.current.enqueueSnackbar(queue.message);
			clearMessage();
		}
	}, [queue, snackRef]);

	function onClickDismiss(key: SnackbarKey): void {
		snackRef.current?.closeSnackbar(key);
	}

	return (
		<NotistackProvider
			action={(key: SnackbarKey) => (
				<IconButton onClick={() => onClickDismiss(key)}>
					<ClearIcon className="snackbar-clear-icon" />
				</IconButton>
			)}
			ref={snackRef}
			maxSnack={3}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center'
			}}
			className="snackbar-popup"
		>
			{children}
		</NotistackProvider>
	);
}

function mapStateToProps(state: AppState) {
	return {
		queue: state.snackbar.queue
	};
}

function mapDispatchToProps(dispatch: AppThunkDispatch<SnackbarActions>) {
	return {
		clearMessage: () => dispatch(clearMessage())
	};
}

export const SnackbarProvider = connect(
	mapStateToProps,
	mapDispatchToProps
)(SnackbarProviderView);
